import React, {PropTypes, Component} from 'react';
import { connect } from 'react-redux';
import UsersTable from './UsersTable';
import Button from '../../../../../common/components/Button';
import Search from '../../../../../common/components/Search';
import { getUsers } from '../../../../../redux/actionCreators/async/employees';
import { storeEmployees } from '../../../../../redux/actionCreators/sync/employees';
import CreateUser from '../Create';
import EditUser from '../Edit/index';

import {chain, intersectionWith} from 'lodash';

@connect((store) => ({
      employees: store.employees
  }), {
  getUsers,
  storeEmployees
})
export default class SettingsUserTab extends Component {

  static propTypes = {
    getUsers: PropTypes.func.isRequired,
    storeEmployees: PropTypes.func.isRequired,
    employees: PropTypes.array.isRequired
  }

  static defaultProps = {
    employees: []
  };

  constructor() {
    super();

    this.state = {
      terms: [],
      createUser: false,
      editUser: false,
    };

  }

  componentDidMount() {
    this.props.getUsers({everyone: true, roleName: 'all', categoriesName: 'all'})
      .then(employeeList => this.props.storeEmployees(employeeList));
  }

  onTermChange(terms = []) {
    this.setState({terms});
  }

  onClose = () => {
    this.setState({createUser: false, editUser: false});
  }

  showCreateUserModal() {
    this.setState({createUser: true});
  }

  showEditUserModal(employee) {
    this.setState({editUser: true, employee});
  }

  render() {

    const transform = employee => ({
        ...employee,
        name: `${employee.firstName} ${employee.lastName}`,
    });

    const matchCriteria = (employee) => {

        const isLowerCaseOrIgnore = term => typeof term === 'string' ? term.toLowerCase() : term;

        const terms = chain(employee)
          .values()
          .map(isLowerCaseOrIgnore)
          .value();

        const searchTerms = this.state.terms.map(isLowerCaseOrIgnore);

        const comparator = (value, otherValue) => typeof value === 'string' && value.search(otherValue) !== -1;

        if(this.state.terms.length) {
          return intersectionWith(terms, searchTerms, comparator).length;
        }

        return true;

    };

    const employees = chain(this.props.employees)
      .map(transform)
      .filter(matchCriteria)
      .value();

    return (
    <div className='settings-user-tab'>
      {this.state.createUser && <CreateUser onClose={this.onClose} employees={this.props.employees} />}
      {this.state.editUser && <EditUser onClose={this.onClose} employee={this.state.employee} employees={this.props.employees} />}
      <Search
        onTermChange={::this.onTermChange}
        baseUrl='/admin/settings/users'
      />
      <h1 className='title'>User Settings</h1>
      <UsersTable
        className='settings-user-table'
        users={employees}
        showEditUserModal={::this.showEditUserModal}
       />
      <Button
          onClick={::this.showCreateUserModal}
          data-id='add-user'
          className='button-main button-main-add-user'
          label='Add User' />
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Settings/User/Landing/index.js